import { z } from 'zod'

export const companies = [
	{
		value: 'aja Bad Saarow (aja Resort und Hotel GmbH)',
		label: 'aja Bad Saarow (aja Resort und Hotel GmbH)',
	},
	{
		value: 'aja Bergresort Werfenweng (Bergresort Werfenweng Hotelbetriebsgesellschaft mbH)',
		label: 'aja Bergresort Werfenweng (Bergresort Werfenweng Hotelbetriebsgesellschaft mbH)',
	},
	{
		value: 'aja Fürstenhaus Achensee (Fürstenhaus am Achensee Pertisau Hotelbetriebsgesellschaft mbH)',
		label: 'aja Fürstenhaus Achensee (Fürstenhaus am Achensee Pertisau Hotelbetriebsgesellschaft mbH)',
	},
	{
		value: 'aja Garmisch-Partenkirchen (aja Resort und Hotel GmbH)',
		label: 'aja Garmisch-Partenkirchen (aja Resort und Hotel GmbH)',
	},
	{
		value: 'aja Grömitz (aja Resort und Hotel GmbH)',
		label: 'aja Grömitz (aja Resort und Hotel GmbH)',
	},
	{
		value: 'aja Ruhpolding (aja Resort und Hotel GmbH)',
		label: 'aja Ruhpolding (aja Resort und Hotel GmbH)',
	},
	{
		value: 'aja Strandhotel Bansin (Strandhotel Bansin Hotelbetriebsgesellschaft mbH)',
		label: 'aja Strandhotel Bansin (Strandhotel Bansin Hotelbetriebsgesellschaft mbH)',
	},
	{
		value: 'aja Travemünde (aja Resort und Hotel GmbH)',
		label: 'aja Travemünde (aja Resort und Hotel GmbH)',
	},
	{
		value: 'aja Warnemünde (aja Resort Warnemünde GmbH)',
		label: 'aja Warnemünde (aja Resort Warnemünde GmbH)',
	},
	{
		value: 'A-ROSA Collection Ceres am Meer (A-ROSA Collection Betriebsgesellschaft mbH)',
		label: 'A-ROSA Collection Ceres am Meer (A-ROSA Collection Betriebsgesellschaft mbH)',
	},
	{
		value: 'A-ROSA Collection Zürs (A-ROSA Collection Zürs GmbH)',
		label: 'A-ROSA Collection Zürs (A-ROSA Collection Zürs GmbH)',
	},
	{
		value: 'A-ROSA Gardasee (Travel Charme Salo S.r.L.)',
		label: 'A-ROSA Gardasee (Travel Charme Salo S.r.L.)',
	},
	{
		value: 'A-ROSA Ifen Hotel Kleinwalsertal (Ifen Hotel Kleinwalsertal Hotelbetriebsgesellschaft mbH',
		label: 'A-ROSA Ifen Hotel Kleinwalsertal (Ifen Hotel Kleinwalsertal Hotelbetriebsgesellschaft mbH',
	},
	{
		value: 'A-ROSA Kurhaus Binz (Kurhaus Binz Hotelbetriebsgesellschaft mbH)',
		label: 'A-ROSA Kurhaus Binz (Kurhaus Binz Hotelbetriebsgesellschaft mbH)',
	},
	{
		value: 'A-ROSA Ostseehotel Kühlungsborn (Ostseehotel Kühlungsborn Hotelbetriebsgesellschaft mbH)',
		label: 'A-ROSA Ostseehotel Kühlungsborn (Ostseehotel Kühlungsborn Hotelbetriebsgesellschaft mbH)',
	},
	{
		value: 'A-ROSA Strandidyll Heringsdorf (Strandidyll Heringsdorf Hotelbetriebsgesellschaft mbH)',
		label: 'A-ROSA Strandidyll Heringsdorf (Strandidyll Heringsdorf Hotelbetriebsgesellschaft mbH)',
	},
	{ value: 'A-ROSA Sylt (AROSA Resort GmbH)', label: 'A-ROSA Sylt (AROSA Resort GmbH)' },
	{
		value: 'A-ROSA Travemünde (AROSA Resort GmbH)',
		label: 'A-ROSA Travemünde (AROSA Resort GmbH)',
	},
	{
		value: 'Badeschloss Hotel Est. 1791 (Badeschloss Bad Gastein Hotelbetriebsgesellschaft mbH)',
		label: 'Badeschloss Hotel Est. 1791 (Badeschloss Bad Gastein Hotelbetriebsgesellschaft mbH)',
	},
	{ value: 'DSR Hospitality Verwaltungs GmbH', label: 'DSR Hospitality Verwaltungs GmbH' },
	{ value: 'DSR Hotel Holding GmbH', label: 'DSR Hotel Holding GmbH' },
	{
		value: 'Gothisches Haus Wernigerode Hotelbetriebsgesellschaft mbH',
		label: 'Gothisches Haus Wernigerode Hotelbetriebsgesellschaft mbH',
	},
	{
		value: 'HENRI Berlin (HENRI Hotel Berlin GmbH)',
		label: 'HENRI Berlin (HENRI Hotel Berlin GmbH)',
	},
	{
		value: 'HENRI Düsseldorf (HENRI Hotel Düsseldorf GmbH)',
		label: 'HENRI Düsseldorf (HENRI Hotel Düsseldorf GmbH)',
	},
	{ value: 'HENRI Hamburg (HENRI Hotel GmbH)', label: 'HENRI Hamburg (HENRI Hotel GmbH)' },
	{
		value: 'HENRI Kitzbühel (HENRI Hotel AT GmbH)',
		label: 'HENRI Kitzbühel (HENRI Hotel AT GmbH)',
	},
	{ value: 'HENRI Seefeld (HENRI Hotel AT GmbH)', label: 'HENRI Seefeld (HENRI Hotel AT GmbH)' },
	{ value: 'HENRI Wien (HENRI Hotel AT GmbH)', label: 'HENRI Wien (HENRI Hotel AT GmbH)' },
	{ value: 'Hotel Louis C. Jacob GmbH', label: 'Hotel Louis C. Jacob GmbH' },
	{ value: 'Neptun Betriebsgesellschaft mbH', label: 'Neptun Betriebsgesellschaft mbH' },
	{
		value: 'Nordperd Göhren Hotelbetriebsgesellschaft mbH',
		label: 'Nordperd Göhren Hotelbetriebsgesellschaft mbH',
	},
	{
		value: 'Straubinger Grand Hotel Bad Gastein (Badeschloss Bad Gastein Hotelbetriebsgesellschaft mbH)',
		label: 'Straubinger Grand Hotel Bad Gastein (Badeschloss Bad Gastein Hotelbetriebsgesellschaft mbH)',
	},
	{ value: 'Travel Charme Hotel GmbH & Co. KG', label: 'Travel Charme Hotel GmbH & Co. KG' },
	{
		value: 'Urban Nature (UN St. Peter-Ording Hotelbetrieb GmbH)',
		label: 'Urban Nature (UN St. Peter-Ording Hotelbetrieb GmbH)',
	},
]

export const bookingForValues = {
	ME: 'me',
	OTHER: 'other',
} as const

const isPhoneNumber = (str: string) => {
	if (!str) return false
	const regex = /^\+?\d[\d\s]*$/
	return regex.test(str)
}

const START_WITH_NUMBER = /^\d/

export const createFormSchema = (country?: string) =>
	z.object({
		name: z.string().min(1, 'guest-data-error-name'),
		surname: z.string().min(1, 'guest-data-error-surname'),
		email: z.string().email('guest-data-error-email'),
		phoneNumber: z
			.string()
			.min(1, 'guest-data-error-phoneNumber')
			.refine((value) => isPhoneNumber(value), { message: 'guest-data-error-phoneNumber' }),
		country: z
			.string({ message: 'guest-data-error-country' })
			.min(1, 'guest-data-error-country'),
		postCode: z.string().refine(
			(value) => {
				if (country?.toLowerCase() === 'ch') return value.length === 4
				if (country?.toLowerCase() === 'at') return value.length === 4
				if (country?.toLowerCase() === 'de') return value.length === 5

				return value?.length > 0
			},
			{ message: 'guest-data-error-postCode' }
		),
		city: z.string().min(1, 'guest-data-error-city'),
		street: z.string().min(1, 'guest-data-error-street'),
		streetNumber: z
			.string()
			.min(1, 'guest-data-error-streetNumber')
			.regex(START_WITH_NUMBER, 'guest-data-error-streetNumber'),
		employeesPromotion: z
			.object({
				company: z.string().min(1, 'guest-data-error-name'),
				employeeName: z.string().min(1, 'guest-data-error-name'),
				companyRelationship: z.string().min(1, 'guest-data-error-name'),
			})
			.optional()
			.nullish(),
		bookingFor: z.enum([bookingForValues.ME, bookingForValues.OTHER]),
		room: z.array(
			z.array(
				z.object({
					id: z.number(),
					name: z
						.string({ message: 'guest-data-error-name' })
						.min(1, 'guest-data-error-name'),
					surname: z
						.string({ message: 'guest-data-error-surname' })
						.min(1, 'guest-data-error-surname'),
					age: z.number().optional().nullish(),
				})
			)
		),
		newsLetter: z.boolean().optional().nullish(),
		annotation: z.string().optional().nullish(),
	})

export type FormValues = z.infer<ReturnType<typeof createFormSchema>>
